<template>
    <div>
        <modal class="share-social-media" :display="modalStatus.bizShareSocialMedia" @modalStatus="closeModal" >
            <h1>分享房源</h1>
            <div class="share-social-media-wrap">
               <ul>
                   <li @click="shareFacebook()">
                       <img src="@/assets/img/social/facebook_gray.svg" alt="">
                       facebook
                   </li>
                   <li @click="shareLine()">
                       <img src="@/assets/img/social/line_gray.svg" alt="">
                       line
                   </li>
                    <a :href="`mailto:to?subject=subject&body=${houseShareText} 網址：${encodeURIComponent(houseUrl+'&platform=p003')}`">
                        <li>
                            <img src="@/assets/img/social/email_gray.svg" alt="">
                            電子郵件
                        </li>
                    </a>
                   <li @click="shareLink()">
                       <div id="link-copy">{{houseUrl}}</div>
                       <img src="@/assets/img/social/copy_gray.svg" alt="">
                       <span ref="link">
                        複製連結
                       </span>
                   </li>
               </ul>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    baseWebUrl
    } from "@/apis/api.js"; 
export default {
    data () {
        return {
            houseName: null,
            houseDescription: null,
            houseMonthly: 0,
            houseType: null,
        }
    },
    props: {
        cid: null,
    },
    watch: {
        cid: function (val) {
            if(val){
                this.getHouseDetail()
            }
        },
        // 'modalStatus.bizShareSocialMedia': function (val) {
        //     if(val){
        //         this.$analyticsBiz.logEvent('分享房源', { screen_name: '分享房源'})
        //     }
        // }
    },
    methods: {
        getHouseDetail: function () {
            const data = {
                houseCid: this.cid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let house = res.data.result.houseDetail
                    this.houseName = house.name
                    this.houseDescription = house.description
                    this.houseMonthly = house.rentMonthly
                    this.houseType = house.houseType
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        shareFacebook: function () {
            this.$analyticsBiz.logEvent('分享房源_FB', { screen_name: '分享房源_FB'})
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseWebUrl+'shareHouse?cid='+this.cid+'&platform=p001')}&quote=${encodeURIComponent(this.houseShareText)}`, '_blank', 'toolbar=0,status=0,width=500,height=300')
        },
        shareLine: function () {
            this.$analyticsBiz.logEvent('分享房源_LINE', { screen_name: '分享房源_LINE'})
            window.open(`https://lineit.line.me/share/ui?url=${encodeURIComponent(baseWebUrl+'shareHouse?cid='+this.cid+'&platform=p002')}&text=${encodeURIComponent(this.houseShareText)}`);
        },
        shareLink: function () {
            this.$analyticsBiz.logEvent('分享房源_複製連結', { screen_name: '分享房源_複製連結'})
            window.getSelection().removeAllRanges()
            const copyDOM = document.getElementById('link-copy');
            const range = document.createRange()
            range.selectNode(copyDOM)
            window.getSelection().addRange(range)
            let successful = document.execCommand("copy");
            console.log(successful)
            window.getSelection().removeAllRanges()
            this.$refs.link.innerText = '連結已複製'
            setTimeout(()=>{
                this.$refs.link.innerText = '複製連結'
            }, 3000)
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizShareSocialMedia'})
        },
    },
    computed: {
        houseShareText: function () {
            return '快瞧瞧飛豬找房上的案件：'+this.houseName+'！ - '+this.transHouseType(this.houseType) +' '+this.toCurrency(this.houseMonthly)+'元/月'
        },
        houseUrl: function () {
            return baseWebUrl+'shareHouse?cid='+this.cid
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.share-social-media{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 342px;
            padding: 32px;
            .detail{
                >h1{
                    margin-bottom: 16px;
                }
                .share-social-media-wrap{
                    width: 100%;
                    ul{
                        li{
                            display: flex;
                            align-items: center;
                            padding: 14px 0;
                            border-bottom: 1px solid #f3f3f3;
                            color: #676362;
                            cursor: pointer;
                            img{
                                margin-right: 16px;
                            }
                            #link-copy{
                                position: absolute;
                                width: 1px;
                                height: 1px;
                                overflow: hidden;
                            }
                        }
                        li:hover{
                            color: #ff9275;
                        }
                        a{
                            border-bottom: 1px solid #f3f3f3;
                        }
                        >*:last-child{
                            border-bottom: 0;
                        }
                    }
                }
            }
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/shareSocialMedia.vue